import { currentCompany } from '../../actionTypes';

const initialState = {
  stack: null,
  loading: true,
  success: false,
  error: false,
};

export default function injuryIllness(state = initialState, action) {
  switch (action.type) {
    case currentCompany.injuryIllness.get.start:
      return initialState;

    case currentCompany.injuryIllness.get.end:
      return {
        ...state,
        stack: action.payload.stack,
        loading: false,
      };

    case currentCompany.injuryIllness.get.error:
      return {
        ...state,
        loading: false,
      };

    case currentCompany.injuryIllness.update.start:
      return { ...state, loading: true };

    case currentCompany.injuryIllness.update.end:
      return {
        ...state,
        stack: action.payload,
        loading: false,
        success: true,
        error: false,
      };

    case currentCompany.injuryIllness.update.error:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
}
